<template>
  <div class=" o_list">   
    <van-nav-bar
      class="bar"
      title="退货单"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    <!-- <div class="fans">暂无退货商品~</div> -->
    <div
      class="name list"
      @click="go(v)"
      v-for="(v,i) in list"
      :key='v.id'
      
    >
      <div class="centen">       
      退货申请单{{$route.query.id==1?'':'草稿'}} {{i+1}}
      </div>
      <div v-show="$route.query.id!=1" @click.stop @click="colse(v)" class="jian">
        <van-icon name="cross" />
      </div>
    </div>
    
    <div class="zu">
       
    </div>

      <!-- <div class="but">
        <van-button
          type="danger"
          size="large"
          @click="onClickLeft"
        >退出</van-button>
      </div> -->
  </div>
</template>
<script>
import Vue from 'vue'
// import List from './child/list'
import { NavBar, Tab, Tabs, List, Cell, Search, Dialog, Toast, CountDown } from 'vant'

Vue.use(NavBar).use(Tabs).use(Tab).use(Cell).use(List).use(Search).use(Dialog).use(CountDown)
export default {
  created () {
    this.axios.post('backOrderList', { draft : this.$route.query.id==1?0:1  }).then(res => {
        console.log(res)
        this.list=res.data.data
      }).catch(ref => { })

  },
  mounted () {
   
  },
  beforeDestroy () {
    


  },

  data () {
    return {
      value: '',
      title: '订单列表',
      nav: ['未结算', '已提交', '待发货', '发货中','已完成','已取消'],
      active: 1,
      states: true,
      list: [],
      loading: false,
      finished: false,
      page: 1,
    }
  },
  methods: {
    
    onClickLeft () {
      this.$router.push('my')
    },
    
    go(v){
        console.log(v)
        this.$store.state.tgood=[v]

      this.$router.push({name:'tui1',query:{id:this.$route.query.id==1?1:0}})

    },
    colse(v){
         Dialog.confirm({
        title:'是否确认取消订单',
        message: '',

      }).then(() => {
        this.axios.post('deleteBackOrder', { back_order_id: v.id }).then(res => {
         
          console.log(res)
          Toast(res.data.msg)
          this.axios.post('backOrderList', { draft : 1  }).then(res => {
        console.log(res)
        this.list=res.data.data
      }).catch(ref => { })

        }).catch(ref => { })
      }).catch(() => {
      })
    }
    
  },
  components: {
    // List
  }
}
</script>
<style lang="less" scoped>
.fans{
  text-align: center;
  font-size: 0.45rem;
  padding-top: 1rem;
}
.o_list {
  padding-top: 1.2rem;
  .bar {
    z-index: 99;
  }
}
.zu{
    color: rgb(245, 9, 9);
    text-align: center;
}
.name {
  display: flex;
  height: 2.08rem;
  background-color: #fff;
  padding: 0.2rem;
  border-bottom: 1px solid #eee;
  .tu {
    flex: 0.3;
    img {
      width: 1.52rem;
    }
  }
  .centen {
    flex: 1;
    padding-top: 0.2rem;
    .top {
      font-size: 0.4rem;
      color: #333;
    }
    .bottom {
      padding-top: 0.2rem;
      font-size: 0.26rem;
      color: #999;
    }
  }
  .jian {
    flex: 0.13;
    padding-top: 0.6rem;
    font-size: 0.5rem;
    color: #e3e3e3;
  }
  .renz{
    flex: 0.33;
    padding-top: 0;
  }
}
.list {
  padding-left: 0.5rem;
  height: 1.3rem;
  .centen {
    font-size: 0.38rem;
  }
  .jian {
    flex: 0.1;
    padding-top: 0.2rem;
  }
}
.but{
    width: 100%;
    position: fixed;
    bottom: 0;
}
</style>
